import { Component } from '@angular/core';
import {BreadcrumbHeaderComponent} from '../../LandingPage/NavigationMenu/page-headline/page-headline.component';

@Component({
  selector: 'app-agbs',
  standalone: true,
  imports: [
    BreadcrumbHeaderComponent
  ],
  templateUrl: './agbs.component.html',
  styleUrl: './agbs.component.scss'
})
export class AgbsComponent {

}
